import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CategoriasServico } from '../models/Servico.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CategoriaServicoService {
  constructor(private http: HttpClient) {}

  getVerificarComunicado() {
    return this.http.head(
      'https://traefik.casan.com.br/static/imagens/site/comunicado-servicos.png'
    );
  }

  getAllCategorias(): Observable<Array<CategoriasServico>> {
    const URL = `/api/servicos/categorias`;
    return this.http.get<Array<CategoriasServico>>(URL);
  }
}
